// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SingleEvent_sectionHeader__6FXCr","swiper":"SingleEvent_swiper__KJTl7","svg-turquoise":"SingleEvent_svg-turquoise__9s6d8"};